export enum StatsElementSimpleGridModifier {
  StickySecondColumn = 'stickySecondColumn',
  StickyFirstColumn = 'stickyFirstColumn',
}
